/** Query-key factory for the Reports feature. Only the three dropdown sources need keys today —
 *  the four grids are keyed by `<DataTable>`'s own `tableId`. Each meta key varies by `search`
 *  because `useCursorSelect` resets its cursor when the key changes, and a cursor is only valid for
 *  the term it was issued under. All three tabs that use the Customers dropdown share one key, so
 *  the option list is fetched once. */
export const reportKeys = {
  all: ['reports'] as const,
  metaCustomers: (search: string) => [...reportKeys.all, 'meta', 'customers', search] as const,
  metaDevices: (search: string) => [...reportKeys.all, 'meta', 'devices', search] as const,
  metaCategories: (search: string) => [...reportKeys.all, 'meta', 'categories', search] as const,
};
